import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { faInfoCircle, faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CommonService } from 'src/app/share/services/common/common.service';
import { LookupService } from 'src/app/share/services/lookup/lookup.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import {SdexAdminService} from 'src/app/share/services/sdex/sdex-admin.service';

@Component({
  selector: 'app-add-workflow',
  templateUrl: './add-workflow.component.html',
  styleUrl: './add-workflow.component.scss'
})
export class AddWorkflowComponent implements OnInit {

  @Input() mode: 'create' | 'update' | 'view' = 'create';
  @Input() workflowData: any = null;
  @Input() company : string;
  @Output() closePopup: EventEmitter<any> = new EventEmitter();

  faTrash: any = faTrash
  faSquarePlus: any = faSquarePlus
  faInfoCircle : any = faInfoCircle;
  workflowForm!: FormGroup;
  departmentsData: any = [];
  selfDetails: any;
  selectedDocumentType: any = null;
  showErorToaster: boolean = false;
  showSuccessToaster: boolean = false;
  toasterMessage: string = '';
  usersList: any = [];
  lastSelectedQuery:any;
  seletedPage:number = 0;
  lastSelectedIndex: any;
  verifyLoader: boolean = false;


  remainderTypeData: any = [
    {
      name: 'Hours',
      value: "hours"
    },
    {
      name: "Days",
      value: "days"
    }
  ]

  documentCategoryData: any = [];
  constructor(
    private fb: FormBuilder,
    private lookupService: LookupService,
    private storageService: StorageService,
    public commonService : CommonService,
  ) {


  }

  ngOnInit() {
    this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.createWorkflowForm();
    this.getDocumentTypeList();
    this.getDepartmentList();

    if (this.mode !== 'create' && this.workflowData) {
      this.pathWorkflowForm();
    }

  }

  getDocumentTypeList() {
    let company = this.company;
    if(this.mode == 'update' && this.workflowData) {
      company = this.workflowData?.company || this.selfDetails?.company;
    }
    let params = {
      company : company
    }
    this.lookupService.getDocumentTypeList(params)?.subscribe({
      next: (res) => {
        if (res.success) {
          this.documentCategoryData = res.data;
        }
      },
      error: (err) => {
      },
    });
  }

  getDepartmentList() {
    let company = this.company;
    if(this.mode == 'update' && this.workflowData) {
      company = this.workflowData?.company || this.selfDetails?.company;
    }
    let params = {
      company : company
    }
    this.lookupService.getDepartments(this.selfDetails?.company,params).subscribe({
      next: (res) => {
        this.departmentsData = res.data;
      },
      error: (err) => {
      },
    });
  }

  createWorkflowForm() {
    this.workflowForm = this.fb.group({
      name: ['', Validators.required],
      documentType: ['', Validators.required],
      description: ['', Validators.required],
      stages: this.fb.array([this.createStage('Stage 1')])
    });
  }

  pathWorkflowForm() {
    if (this.workflowData) {
      this.workflowForm.patchValue({
        name: this.workflowData.name,
        documentType: this.workflowData.documentType._id,
        description: this.workflowData.description,
      });

      this.stages.clear();
      this.workflowData.stages.forEach((stage: any) => {
        const stageGroup = this.createStage();
        stageGroup.patchValue({
          name: stage.name,
          department: stage.departments[0]?.departmentId || '',
          users: stage.users.map((item:any)=> item._id),
          notifications: {
            reminderType: stage.notifications?.approvalPeriod || 'days',
            reminderPeriod: stage.notifications?.approval || 1
          }
        });
        this.stages.push(stageGroup);
        this.usersList = [...this.usersList, ...stage.users.map((item:any)=> ({
          _id: item._id,
          name: item.name + '( ' + item.emailAddress + ')',
        }))]
      });
    }
  }

  handleClosePopup(data: any) {
    this.closePopup.emit(data);
  }

  // Getter for stages FormArray
  get stages(): FormArray {
    return this.workflowForm.get('stages') as FormArray;
  }

  stageControls(index: number): any {
    return this.stages.controls[index] as FormGroup;
  }

  // Create a single stage form group
  createStage(defaultName?: string): FormGroup {
    return this.fb.group({
      name: [defaultName || '', Validators.required],
      department: [''],
      users: [[]],
      notifications: this.fb.group({
        reminderType: ['days', Validators.required],
        reminderPeriod: [1, Validators.required]
      })
    }, { validators: [this.atLeastOneSelectRequired('department', 'users')] });
  }

  atLeastOneSelectRequired(controlA: string, controlB: string) {
  return (group: AbstractControl): ValidationErrors | null => {
    const a = group.get(controlA)?.value || '';
    const b = group.get(controlB)?.value || [];
    return (a.trim() !== '' || b.length > 0) ? null : { atLeastOneSelect: true };
  };
}
  // Add new stage to the FormArray
  addStage(): void {
    const stageNumber = this.stages.length + 1;
    this.stages.push(this.createStage('Stage ' + stageNumber));
  }

  // Remove a stage by index
  removeStage(index: number): void {
    if (this.stages.length > 1) {
      this.stages.removeAt(index);
    }
  }

  // Submit form
  onSubmit(): void {
    let payload = this.workflowForm.value;
    payload.stages = payload.stages.map((stage: any) => {
      return {
        name: stage.name,
        departments: stage.department ? [{ departmentId: stage.department }] : [],
        users: stage.users ? stage.users : [],
        notifications: {
          approvalPeriod: stage.notifications.reminderType,
          approval: stage.notifications.reminderPeriod
        }
      };
    })
    if (this.workflowForm.valid) {
      this.verifyLoader = true;
      if(this.mode == 'update') {
        this.lookupService.updateWorkflow(this.selfDetails.company,this.workflowData._id,this.workflowForm.value).subscribe({
          next: (res: any) =>{
            this.handleClosePopup({mode : 'Create', data: res.data});
            this.verifyLoader=false;
          },
          error: (err: any) => {
            this.showErorToaster = true;
            this.toasterMessage = err?.error?.error?.message || 'Something went wrong, please try again later';
            this.verifyLoader=false;
          }
        })
      }else{
        this.lookupService.createWorkflow(this.selfDetails.company,this.workflowForm.value).subscribe({
          next: (res: any) =>{
                this.closePopup.emit({isSuccess:true});
                this.verifyLoader=false;

          },
          error: (err: any) => {
            this.showErorToaster = true;
            this.toasterMessage = err?.error?.error?.message || 'Something went wrong, please try again later';
            this.verifyLoader=false;
          }
        })
      }

    } else {
      this.workflowForm.markAllAsTouched();
    }
  }

  closeToaster() {
    this.showErorToaster = false;
    this.showSuccessToaster = false;
    this.toasterMessage = '';
  }

  getUsersList(index: any, query: string = '', page: number = 0, isLoadMore: boolean = false) {
    const stageControl = this.stages.at(index) as FormGroup;
    const selectedDept = stageControl.get('department')?.value;
    const selectedUsers = stageControl.get('users')?.value || [];
    if (!isLoadMore && (query !== this.lastSelectedQuery || index !== this.lastSelectedIndex)) {
      this.lastSelectedQuery = query;
      this.lastSelectedIndex = index;
      this.seletedPage = 0;
      this.usersList = [];
    }
    const params: any = {
      page: this.seletedPage,
      name_like: this.lastSelectedQuery || '',
    };
    this.lookupService.getParentUsers(params)?.subscribe({
      next: (res: any) => {
        const apiUsers = res.data.map((x: any) => ({
          _id: x._id,
          name: x.name + '( ' + x.emailAddress + ')',
          departments: x.departments || [],
        }));
        const filteredUsers = apiUsers.filter(
          (u: any) => (selectedDept ? !u.departments.includes(selectedDept) : true)
        );
        if (isLoadMore) {
          const existingIds = new Set(this.usersList.map((u: any) => u._id));
          const toAdd = filteredUsers.filter((u: any) => !existingIds.has(u._id));
          this.usersList = [...this.usersList, ...toAdd];
          this.seletedPage++;
        } else {
          this.usersList = filteredUsers;
        }
        this.usersList.forEach((item: any) => {
          item.checked = selectedUsers.includes(item._id);
        });
      },
      error: (err) => {
        this.showErorToaster = true;
        this.toasterMessage = err?.error?.error?.message || 'Something went wrong, please try again later';
      },
    });
  }


  onSelectUser(index:any, selectedValue:any) {
    const usersControl = this.stages.at(index) as FormGroup;
    usersControl.get('users')?.setValue(selectedValue);
  }

  onDepartmentChange(index: number) {
    const stageControl = this.stages.at(index) as FormGroup;
    stageControl.get('users')?.setValue([]);
    this.usersList = [];
    this.getUsersList(index);
  }


}
